function addNewProtocol() {
  return {
    storageKey: 'product_recommend__add_new',
    allowedUrl: null,
    errorTimeout: null,

    init() {
      this.$nextTick(() => {
        const form = this.$el.closest('.add-protocol__form');
        if (!form) return;

        const fields = form.querySelectorAll(
          'input[required], textarea[required]'
        );

        fields.forEach((field) => {
          field.addEventListener('input', () => {
            if (field.value && field.value !== '') {
              field.parentElement.classList.remove('error');
            }
          });
        });
        this.loadFromStorage();
      });
    },
    loadFromStorage() {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return;

      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        console.warn('Invalid protocol storage data');
        return;
      }

      if (!data?.body) return;

      const titleEl = document.querySelector('#protocol-title');
      const instructionsEl = document.querySelector('#protocol-details');

      if (titleEl && data.body.title) {
        titleEl.value = data.body.title;
        titleEl.dispatchEvent(new Event('input'));
      }

      if (instructionsEl && data.body.note) {
        let text = '';

        if (typeof data.body.note === 'string') {
          const note = data.body.note.trim();

          if (note.startsWith('{') || note.startsWith('[')) {
            try {
              const json = JSON.parse(note);
              text =
                json?.children?.[0]?.children
                  ?.filter(n => n.type === 'text')
                  .map(n => n.value)
                  .join('\n') || '';
            } catch (e) {
              console.warn('Note is not valid JSON, fallback to plain text');
              text = note;
            }
          } else {
            text = note;
          }
        }
        instructionsEl.value = text;
        instructionsEl.dispatchEvent(new Event('input'));
      }
    },

    validateForm() {
      const form = this.$el.closest('.add-protocol__form');
      if (!form) return true;

      const fields = form.querySelectorAll(
        'input[required], textarea[required]'
      );

      let isValid = true;

      fields.forEach((field) => {
        const hasValue = field.value && field.value.trim() !== '';

        if (!hasValue) {
          isValid = false;
          field.parentElement.classList.add('error');
        } else {
          field.parentElement.classList.remove('error');
        }
      });

      if (!isValid) {
        form.classList.add('error-submit');

        clearTimeout(this.errorTimeout);
        this.errorTimeout = setTimeout(() => {
          form.classList.remove('error-submit');
        }, 5000);
      }

      return isValid;
    },

    handleAddSubmit(allowedUrl, customerId) {
      if (!this.validateForm()) return;

      const titleEl = document.querySelector('#protocol-title');
      const instructionsEl = document.querySelector('#protocol-details');

      const newBody = {
        customer_id: customerId != null ? customerId : null,
        title: titleEl ? titleEl.value : '',
        note: instructionsEl ? instructionsEl.value : '',
        protocol_value: true
      };

      let existing;
      try {
        existing = JSON.parse(localStorage.getItem(this.storageKey)) || {};
      } catch (e) {
        existing = {};
      }

      const payload = {
        ...existing,
        body: {
          ...(existing.body || {}),
          ...newBody
        }
      };

      localStorage.setItem(this.storageKey, JSON.stringify(payload));

      this.allowedUrl = allowedUrl;
      window.location.href = allowedUrl;
    }
  }
}